import { Button } from '@rocketlane/ui';
import styled from 'styled-components';

export const LoadMore = styled(Button).attrs({ variant: 'ghost' })`
  width: 100%;
  border: 1px solid var(--divider-default) !important;
  color: var(--text-selected) !important;
  justify-content: center !important;
`;
